export default "__VITE_ASSET__C2_3NTQ2__"